import { createSlice } from '@reduxjs/toolkit';

export const ordenesDeServicioSlice = createSlice({
  name: 'ordenesDeServicio',
  initialState: {
    camposOrdenesDeServicio: [],
    parametros_list: [],
    fieldListSelect: [],
    parametro: {},
  },
  reducers: {
    setFieldsOrdenesServiciosRedux: (state, { payload }) => {
      state.camposOrdenesDeServicio = payload;
    },
    setParametrosRedux: (state, { payload }) => {
      state.parametros_list = payload;
    },
    storeParametrosRedux: (state, { payload }) => {
      state.parametro = payload;
    },
    storeParameterRedux: (state, { payload }) => {
      state.parametro = payload;
    },
    setFieldsForSelectRedux: (state, { payload }) => {
      state.fieldListSelect = payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setParametrosRedux,
  storeParametrosRedux,
  storeParameterRedux,
  setFieldsOrdenesServiciosRedux,
  setFieldsForSelectRedux,
} = ordenesDeServicioSlice.actions;
